import {
  ITenant,
  TokenCustomClaimKeysEnum,
} from '@sitecore-ui/portal-singular';
import { t } from '@transifex/native';
import { useMainState } from '../../../main/context';
import MediaCard from '../MediaCard/MediaCard';
import AppBoxEmptyState from './AppBoxEmptyState';
import { APP_ORGANIZATION } from './resource';
import { useAppAccess } from './utils';

import { VStack } from '@chakra-ui/react';

import { isMarketplaceApp } from 'features/common/config/envConfig';
import { useGetAllMarketplaceAppTenants } from 'features/common/hooks/useGetAllMarketplaceAppTenants';
import { iconByProduct } from 'features/subscriptions/utils';

function AppAccess() {
  const state = useMainState();
  const { userRoles, claims } = useAppAccess();

  const { data: marketplaceAppData } = useGetAllMarketplaceAppTenants();
  const hasMarketplaceApp = !!marketplaceAppData?.user?.tenants?.nodes?.length;

  const tenants = state.env?.data.tenants;
  const organizationId = claims && claims[TokenCustomClaimKeysEnum.ORG_ID];
  if (state.env?.ORG_ADMIN_OR_OWNER) {
    return (
      <>
        {state.env?.WITH_APP_ACCESS ? (
          <AppBoxEmptyState
            dataTestId='no-appAccess--admin'
            text={t('You have access to all available apps.')}
          />
        ) : (
          <>
            <AppBoxEmptyState
              dataTestId='no-appAccess--admin'
              text={t('No apps available.')}
            />
          </>
        )}
      </>
    );
  }

  if (state.env?.WITH_NO_TENANTS && !hasMarketplaceApp && state.env?.ORG_USER) {
    return (
      <AppBoxEmptyState
        dataTestId='no-appAccess--user'
        text={t('No apps available. Contact your organization administrator.')}
      />
    );
  }

  if (!organizationId || ((!tenants || !userRoles) && !marketplaceAppData))
    return null;

  const rolesWithTenantInfo = userRoles
    .filter((r) => r.scope !== APP_ORGANIZATION && r.tenantId)
    .map((role) => {
      const tenant = tenants?.find((t: ITenant) => t.id === role.tenantId);

      return {
        ...role,
        tenantDetails: tenant,
      };
    });

  const marketplaceApps =
    marketplaceAppData?.user?.tenants?.nodes?.map((tenant) => ({
      tenantDetails: tenant,
    })) || [];

  return (
    <VStack spacing={4}>
      {[...rolesWithTenantInfo, ...marketplaceApps].map((row, idx) => {
        if (!row.tenantDetails) return;

        const tenantView = isMarketplaceApp(row.tenantDetails?.systemId)
          ? {
              title: 'Marketplace App',
              displayName: row.tenantDetails?.displayName,
              name: 'Marketplace App',
              id: row.tenantDetails?.id,
              icon: row?.tenantDetails?.annotations?.find(
                (annotation: any) => annotation.key === 'IconUrl',
              )?.value,
              subTitle: row.tenantDetails?.displayName,
            }
          : {
              title: row.tenantDetails?.name,
              displayName: row.tenantDetails?.displayName,
              name: row.tenantDetails?.name,
              id: row.tenantDetails?.id,
              icon: iconByProduct[
                (
                  row.tenantDetails as ITenant
                )?.labels?.ProductCode?.toLowerCase()
              ]?.iconUrl,
              subTitle: row.tenantDetails?.displayName,
            };

        const viewModel = tenantView;

        return (
          <MediaCard
            key={idx}
            size={'option'}
            title={viewModel.title}
            label={viewModel.subTitle}
            imageUrl={viewModel.icon}
            iconColor='transparent'
          />
        );
      })}
    </VStack>
  );
}

export default AppAccess;
